import React from 'react'
import {FormularRegister} from '../../Components/FormularRegister/FormularRegister'

function Register() {

  return (
    <div>
      <FormularRegister />
    </div>
  )
}

export default Register
